export default __webpack_public_path__ + "dist/media/Facebook.e09cbbb7.svg";